import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ControlStockModel } from './controlstock.model';
import { ApiResponse } from '../../../models/base';

const LIST_ENDPOINT = '/controlstock';

interface ApiMessageResponse {
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class ControlStockService {
  constructor(private http: HttpClient) {}

  public create(controlstock: ControlStockModel): Promise<ControlStockModel> {
    return firstValueFrom(
      this.http.post<ApiResponse<ControlStockModel>>(
        environment.apiUrl + LIST_ENDPOINT + '/create',
        controlstock
      )
    ).then((response) => response.data);
  }

  public delete(uid: string): Promise<string> {
    const params = new HttpParams().set('uid', uid);

    return firstValueFrom(
      this.http.delete<ApiMessageResponse>(
        environment.apiUrl + LIST_ENDPOINT + '/delete',
        { params }
      )
    ).then((response) => response.message);
  }

  public update(controlstock: ControlStockModel): Promise<ControlStockModel> {
    return firstValueFrom(
      this.http.put<ApiResponse<ControlStockModel>>(
        environment.apiUrl + LIST_ENDPOINT + '/edit',
        controlstock
      )
    ).then((response) => response.data);
  }

  public get(uid: string): Promise<ControlStockModel> {
    const params = new HttpParams().set('stockUid', uid);

    return firstValueFrom(
      this.http.get<ApiResponse<ControlStockModel>>(
        environment.apiUrl + LIST_ENDPOINT + '/get',
        { params }
      )
    ).then((response) => response.data);
  }

  public list(): Promise<ControlStockModel[]> {
    return firstValueFrom(
      this.http.get<ApiResponse<ControlStockModel[]>>(
        environment.apiUrl + LIST_ENDPOINT + '/list'
      )
    ).then((response) => response.data);
  }
}